import axios from "axios";
import { PlaceOrderService } from "../../services/EcommerceService";
import { ADD_CART, GET_CART } from "../ActionTypes";



const dataFetch = async () => {
    return await axios
        .get("/api/cart")
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const fetchCart = () => {
    return async dispatch => {

        const data = await dataFetch();
        // alert(data.data);
        // this.toggleButton(!this.setAlert);
        dispatch({ type: GET_CART, cartData: data });
    };
};

export const addCart = (product_id) => {
    return async dispatch => {

        console.log(product_id)
        const product = {
            product_id: product_id,
            qty: 1,

        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(product)
        };
        const response = await fetch('/api/ajax/cart', requestOptions);

        const data = await dataFetch();
        dispatch({ type: ADD_CART, cartData: data });
    };
};

export const placeOrderAction = (order_data,navigate) => {
    return async dispatch => {
        PlaceOrderService(order_data).then((res) => {
            console.log(res)
            if (res.hasOwnProperty('success') && res.success === true) {
                navigate(`/order/${res.data.order_id}`);
                window.open(res.data.payment_page, "_blank");
                // dispatch({ type: ActionTypes.GET_CART, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                console.log('Kondisi 2')
            } else {
                console.log('Kondisi 3')
            }
        }).catch((error) => {
            // dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    };
};
